<template>
    <div class="filter-anchor mt-3" :class="{'nav-padding': fixedScroll}">
        <div class="filters-desktop d-none d-xl-block rounded-lg" :class="{'fixed-scroll bg-white shadow': fixedScroll == true }">
            <div class="my-2" :class="{'container': fixedScroll == true }">
                <div class="card text-dark border-0" :class="{'bg-white mb-0 border-0': fixedScroll == true, 'mb-3': appliedFilterCount > 0}">
                    <div class="card-body p-0">
                        <div class="top-level d-flex justify-content-between gap-3">
                            <div class="d-flex justify-content-between gap-3">
                                <template v-for="(filter, filter_type) in filters" :key="filter_type">
                                    <div v-if="Object.keys(filter).length" class="filter-heading w-auto my-2 flex-fill p-0">
                                        <div class="dropdown">
                                            <button
                                                v-if="Object.keys(filter).length"
                                                :id="filter_type"
                                                class="form-select text-capitalize dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                {{ Object.keys(filter_type).length ? filter_type.replace('_', ' ').replace('specialist', 'application') : '' }}
                                            </button>
                                            <div class="dropdown-menu" :aria-labelledby="filter_type">
                                                <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : ''" @click.stop="">
                                                    <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                                    {{ item == 'RFT' ? 'Run Flat (RFT)' : item }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <sort-options class="d-none d-sm-block"></sort-options>
                        </div>
                        <div class="applied-filters d-flex align-items-center" v-if="appliedFilterCount > 0">
                            <template v-for="filter, filter_type in this.$parent.selectedFilters" :key="filter_type">
                                <template v-if="filter.length > 0">
                                    <div class="applied-filter-menu d-flex align-items-center" v-if="filter.length > 0">
                                        <label v-for="item, key in filter" :key="key" class="gap-2 w-auto px-0 px-2 d-flex align-items-center justify-content-between badge py-2 me-2 rounded applied-filter-item text-capitalize">
                                            <input type="checkbox" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.homeDelivery)"/>
                                            <div v-if="filter_type == 'fuel' || filter_type == 'wet' || filter_type == 'speed' || filter_type == 'load_index'"><span> {{ filter_type == 'load_index' ? filter_type.replace('_index', '') : filter_type }} - </span>{{ item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                            <div v-else>{{ item == 'RFT' ? 'Run Flat (RFT)' : item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                        </label>
                                    </div>
                                </template>
                            </template>
                            <span class="gap-2 w-auto px-0 px-2 d-flex align-items-center justify-content-between badge rounded btn btn-primary fw-bold text-white" @click="this.$parent.resetFilters()">Clear all <i class="fa-solid fa-xmark mx-1"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-block d-xl-none mb-3 p-2 col-12 g-2 filters-mobile" :class="fixedScroll == true ? 'fixed-scroll bg-white shadow' : 'bg-light'">
            <div class="d-flex align-items-center row-cols-2 gap-3">
                <div class="cursor-pointer p-2 d-flex align-items-center justify-content-between navbar-toggler col" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                    <div>
                        <b class="d-block">Filter</b>
                        <small>{{ appliedFilterCount }} filter{{ appliedFilterCount == 0 || appliedFilterCount > 1 ? 's' : '' }}</small>
                    </div>
                    <i class="fa-kit fa-filter fa-lg"></i>
                </div>
                <sort-options class="d-flex d-xl-none col flex-fill"></sort-options>
            </div>
            <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div class="d-flex align-items-center justify-content-between p-3 mobile-filters-header">
                    <div class="d-flex align-items-center gap-3">
                        <i class="fa-kit fa-chevron-left fa-lg cursor-pointer" data-bs-dismiss="offcanvas" aria-label="Close"></i>
                        <h5 class="offcanvas-title fs-6" id="offcanvasNavbarLabel">Filters</h5>
                    </div>
                    <i class="fa-kit fa-close text-16 cursor-pointer" data-bs-dismiss="offcanvas" aria-label="Close"></i>
                </div>
                <div class="offcanvas-body pt-0">
                    <form id="filter-form" ref="filterForm">
                        <div class="row">
                            <div class="applied-filters d-inline-block mt-2" v-if="appliedFilterCount > 0">
                                <template v-for="filter, filter_type in this.$parent.selectedFilters" :key="filter_type">
                                    <template v-if="filter.length > 0">
                                        <label v-for="item, key in filter" :key="key" class="badge py-2 px-3 me-2 rounded applied-filter-item text-capitalize">
                                            <input type="checkbox" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.homeDelivery)"/>
                                            <div v-if="filter_type == 'fuel' || filter_type == 'wet' || filter_type == 'speed' || filter_type == 'load_index'"><span> {{ filter_type == 'load_index' ? filter_type.replace('_index', '') : filter_type }} - </span>{{ item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                            <div v-else>{{ item == 'RFT' ? 'Run Flat (RFT)' : item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                        </label>
                                    </template>
                                </template>
                                <span class="badge py-2 px-3 rounded bg-primary text-white fw-bold" @click="this.$parent.resetFilters()">Clear all <i class="fa-solid fa-xmark mx-1"></i></span>
                            </div>
                            <div class="accordion p-0" id="mobileFilters">
                                <div class="accordion-item" v-for="(filter, filter_type, index) in filters" :key="filter_type">
                                    <h2 v-if="Object.keys(filter).length" class="accordion-header" :id="filter_type + 'Header'">
                                        <button class="accordion-button px-3 text-capitalize collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#' +filter_type + 'Collapse'" aria-expanded="false" :aria-controls="filter_type + 'Collapse'">
                                            {{ filter_type.replace('_', ' ').replace('specialist', 'application') }}
                                        </button>
                                    </h2>
                                    <div v-if="Object.keys(filter).length" :id="filter_type + 'Collapse'" class="accordion-collapse collapse" :aria-labelledby="filter_type + 'Header'" data-bs-parent="#mobileFilters">
                                        <div class="accordion-body p-2">
                                            <div class="menu-item show">
                                                <template v-if="filter_type == 'range'">
                                                    <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : 'in-active'" @click.stop="">
                                                        <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                                        {{ item }}
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : 'in-active'" @click.stop="">
                                                        <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                                        {{ item == 'RFT' ? 'Run Flat (RFT)' : item }}
                                                    </label>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filters', 'isDisabled'],
        components: {
        },
        data() {
            return {
                speedParam: [],
                loadParam: [],
                originalUrl: window.location.protocol + '//' + window.location.host + window.location.pathname,
                fixedScroll: false
            }
        },
        created() {
            //Runs the loadUrlParams function, so any pre-selected filters are applied.
            this.$parent.loadUrlParams();
            
            //Runs the loadFormData function, so the formData is updated with any newly applied filters.
            this.$parent.loadFormData();

            //Adds an event listener for toggling the fixed filters on/off
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                var filtersOffset = document.querySelector('.filter-anchor').offsetTop;

                if (window.scrollY > filtersOffset) {
                    this.fixedScroll = true;
                } else if (window.scrollY < filtersOffset) {
                    this.fixedScroll = false;
                }
            }
        },
        computed: {
            appliedFilterCount() {
                const filters = Object.values(this.$parent.selectedFilters);
                var count = 0;

                _.forEach(filters, function(filter, key) {
                    _.forEach(filter, function(value, key) { 
                        if(value.length > 0) {
                            count++
                        }
                    });
                });

                return count;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .navbar-toggler {
        border: 1px solid #767676;
        background: #fff;
        border-radius: 4px;
    }
    #filter-form {
        label {
            cursor: pointer;
        }
    }
    //Used on desktop and mobile
    .fixed-scroll {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        box-shadow: 0px 4px 13px rgb(0 0 0 / 7%), 0px 2.59259px 7.61343px rgb(0 0 0 / 5%), 0px 1.54074px 4.14074px rgb(0 0 0 / 4%), 0px 0.8px 2.1125px rgb(0 0 0 / 4%), 0px 0.325926px 1.05926px rgb(0 0 0 / 3%), 0px 0.0740741px 0.511574px rgb(0 0 0 / 2%);
    }
    #mobileFilters {
        .accordion-button::after {
            background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 512" height="10" width="8"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M7.2 6.8c-9.1 9.1-9.1 23.8 0 32.9L223.5 256 7.2 472.3c-9.1 9.1-9.1 23.8 0 32.9s23.8 9.1 32.9 0L256.4 288.9c18.2-18.2 18.2-47.6 0-65.8L40.1 6.8C31-2.3 16.3-2.3 7.2 6.8z"/></svg>') !important;
            height: 21px;
            width: 21px;
            background-size: 21px 21px;
        }
        .accordion-button:not(.collapsed)::after {
            transform: rotate(90deg);
        }
        .accordion-button:not(.collapsed) {
            background: none;
            color: rgb(33, 37, 41);
        }
    }
    .filters-desktop, .filters-mobile {
        .mobile-filters-header {
            background-color: #F6F6F6;
            border-bottom: 1px solid #ccc;
        }
        span, select {
            font-size: 15px;
            cursor: pointer;
        }
        .dropdown-toggle {
            font-size: 15px;
            &::after {
                display: none;
            }
        }
        label {
            &.dropdown-item {
                background-image: url('/assets/icons/inactive-icon.svg');
                background-repeat: no-repeat;
                background-position-x: 10px;
                background-position-y: 6px;
                background-size: 24px 24px;
                padding-left: 41px !important;
                background-repeat: no-repeat;
                background-color: #fff;
                color: #3d3d3d;
                width: auto;
                margin: 5px;
                border: 1px solid #767676;
                border-radius: 4px;
                padding: 7px 10px;
                cursor: pointer;
                text-transform: inherit;
                font-size: 16px;
                font-weight: 600;
                &.active {
                    background-image: url('/assets/icons/active-icon.svg');
                }
            }
        }
        .dropdown-menu, .applied-filters, .menu-item {
            &.show {
                display: flex;
                width: auto;
                @media screen and (min-width: 576px) {
                    width: 480px;
                    padding: 5px;
                    box-shadow: 0px 4px 13px rgb(0 0 0 / 7%), 0px 2.59259px 7.61343px rgb(0 0 0 / 5%), 0px 1.54074px 4.14074px rgb(0 0 0 / 4%), 0px 0.8px 2.1125px rgb(0 0 0 / 4%), 0px 0.325926px 1.05926px rgb(0 0 0 / 3%), 0px 0.0740741px 0.511574px rgb(0 0 0 / 2%);
                }
                flex-wrap: wrap;
            }
            .dropdown-item, .applied-filter-item {
                input {
                    display: none;
                }
            }
        }
        .applied-filters {
            .badge {
                border: 1px solid #ccc;
                color: #3d3d3d;
                font-size: 16px;
                font-weight: 400;
                margin: 5px 5px 5px 0;
                cursor: pointer;
            }
        }
    }
    .filters-mobile {
        @media screen and (max-width: 575px) {
            .offcanvas-start {
                width: 100%; 
            }
        }
        .navbar-toggler {
            &:focus {
                box-shadow: none;
            }
        }
        .menu-item {
            width: auto !important;
        }
    }
    .nav-padding {
        @media screen and (min-width: 1200px) and (max-width: 1399px) {
            padding-top: 128.5px;
        }
        @media screen and (min-width: 1400px) {
            padding-top: 76px;
        }
    }
</style>